export default __webpack_public_path__ + "static/media/Predictor.a2c1c423.png";